import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Clone } from 'src/app/models/tv/tv';
import { AccountService } from 'src/app/services/account/account.service';
import { TvService } from 'src/app/services/tv/tv.service';

@Component({
  selector: 'app-clones',
  templateUrl: './clones.component.html',
  styleUrls: ['./clones.component.scss'],
})
export class ClonesComponent implements OnInit {
  clones: Array<Clone> = [];
  contextmenu: string;
  contextmenuX = 0;
  contextmenuY = 0;
  copiedElement;
  contextElement;
  searchValue: string;
  cloneToDelete;
  constructor(
    private tvService: TvService,
    private router: Router,
    public accountService: AccountService
  ) {}

  ngOnInit(): void {
    this.getClones();
  }

  getClones() {
    this.tvService.getClones(this.accountService.vendor).subscribe((data) => {
      this.clones = data;
    });
  }

  editClone(id) {
    this.router.navigate(['editClone'], { queryParams: { id } });
  }

  deleteClone() {
    this.tvService.deleteClone(this.cloneToDelete.id).subscribe(() => {
      this.getClones();
    });
  }

  //activates the menu with the coordinates
  onrightClick(event, element?, project?) {
    this.contextmenuX = event.clientX;
    this.contextmenuY = event.clientY;
    console.log('context menu', element);
    if (element) this.contextmenu = 'copy';
    else this.contextmenu = 'paste';
    this.contextElement = element;
    if (this.contextElement) {
      this.contextElement.vendor = localStorage.getItem('HechRomeoAccount');
      if (project) this.contextElement.project = true;
    }
  }

  disableContextMenu() {
    this.contextmenu = undefined;
  }
}
